import { getFirstNameLastName } from 'components/common/func';
import {
  PII_PROFILE_APPROVED_STATUS,
  PII_PROFILE_PENDING_DOCUMENTS_STATUS,
  PII_PROFILE_PENDING_PII_STATUS,
} from 'features/pii/const';
import useCommonStore from 'hooks/useCommonStore';

const useProfile = () => {
  const { state, currentUser } = useCommonStore();
  const { status, kycRefresh, firstName, lastName, mobile, email, address } =
    currentUser || {};

  const isProfileStatusApproved = status === PII_PROFILE_APPROVED_STATUS;
  const isProfileStatusPendingDocuments =
    status === PII_PROFILE_PENDING_DOCUMENTS_STATUS;
  const isProfileStatusPendingPII = status === PII_PROFILE_PENDING_PII_STATUS;
  const isProfileKYC = kycRefresh;

  const getProfileFullName = () => {
    if (!firstName || !lastName) return '-';
    return getFirstNameLastName({
      firstName,
      lastName,
    });
  };
  const getProfileFullAddress = () => {
    if (!address?.fullAddress) return '-';
    return address?.fullAddress;
  };

  return {
    ...state,
    currentUser,
    isProfileStatusApproved,
    isProfileStatusPendingDocuments,
    isProfileStatusPendingPII,
    isProfileKYC,
    getProfileFullName,
    getProfileFullAddress,
  };
};

export default useProfile;
